import * as React from 'react';

import {Avatar} from '../avatar/avatar';
import {colors} from '../colors/colors';
import {BoxRegularIcon} from '../icon/svg/box-regular-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CompetitorRegularIcon} from '../icon/svg/competitor-regular-icon';
// @ts-expect-error - imported from .js/.jsx file
import {NoteIcon} from '../icon/svg/note-icon';
import {SourceIcon} from '../icon/svg/source-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TagIcon} from '../icon/svg/tag-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TerritoryIcon} from '../icon/svg/territory-icon';
import {LinkedEntity} from '../linked-entity/linked-entity';

import styles from './entity.module.css';

const STANDARD_TYPES = ['leads', 'accounts', 'contacts', 'users', 'teams'];

export type EntityType =
    | 'tags'
    | 'sources'
    | 'territories'
    | 'products'
    | 'competitors'
    | 'notes'
    | 'leads'
    | 'accounts'
    | 'contacts'
    | 'users'
    | 'teams';

type Props = {
    id: string;
    name: string;
    type: EntityType;
    htmlUrl?: string;
    initials?: string;
    avatarUrl?: string;
    body?: string;
    size: number;
};

export class Entity extends React.PureComponent<Props> {
    static defaultProps = {
        size: 36,
    };

    render() {
        return (
            <div className={styles.container}>
                <div
                    style={{height: this.props.size, width: this.props.size}}
                    className={styles['avatar-container']}
                >
                    {this.renderAvatar()}
                </div>
                {this.renderEntityInfo()}
            </div>
        );
    }

    renderAvatar = (): React.ReactElement<any> | null | undefined => {
        switch (this.props.type) {
            case 'accounts':
            case 'contacts':
            case 'leads':
            case 'users':
            case 'teams': {
                return (
                    <Avatar
                        type={this.props.type}
                        initials={this.props.initials}
                        avatarUrl={this.props.avatarUrl}
                        size={this.props.size}
                    />
                );
            }
            case 'tags':
                return <TagIcon fill={colors.greyDk} size={this.props.size - 10} />;
            case 'sources':
                return <SourceIcon size={this.props.size - 10} />;
            case 'territories':
                return <TerritoryIcon color={colors.greenDk} size={this.props.size - 10} />;
            case 'products':
                // @ts-expect-error
                return <BoxRegularIcon color={colors.greenDk} size={this.props.size - 10} />;
            case 'competitors':
                return <CompetitorRegularIcon size={this.props.size - 10} />;
            case 'notes':
                return <NoteIcon size={this.props.size - 10} />;
            default:
                return undefined;
        }
    };

    renderEntityInfo = (): React.ReactElement<any> | null | undefined => {
        if (STANDARD_TYPES.includes(this.props.type)) {
            return <LinkedEntity {...this.props} />;
        } else if (this.props.type === 'notes' && this.props.body) {
            const notePreview =
                this.props.body.length > 100
                    ? `${this.props.body.substring(0, 300)}…`
                    : this.props.body;

            return (
                <span title={this.props.body} className={styles.info}>
                    {notePreview}
                </span>
            );
        } else {
            return <span className={styles.info}>{this.props.name}</span>;
        }
    };
}
